module.exports = __webpack_public_path__ + "static/media/counterfeitNotify.e75a0cdb.svg";